import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';
import { isOfframpBill } from '../../utils';

import {
  addStatusToTransactions,
  TopBar,
  TransactionDropdown,
} from '../../components';
import { useWidgetContext } from '../../context/WidgetContext';
import links from '../../constants/links';
import { ReactComponent as BookOpenIcon } from '@frontend/icons/book-open.svg';

import { PageFields_KytVerificationStartedPage_Fragment as KytVerificationStartedPage } from '../../graphql/generated';

interface KYTVerificationProps {
  data: KytVerificationStartedPage['pageData'];
}

const KYTVerification = ({ data }: KYTVerificationProps) => {
  const { configureHeader } = useWidgetContext();

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      expiresAt: data?.expiresAt,
      merchantName: data?.merchantName || '',
      billType: data?.billType,
    });
  }, []);

  const isOffRamp = isOfframpBill(data?.billType);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader>
            <WidgetHeaderContent
              title={`Processing ${isOffRamp ? 'off ramp' : 'payment'}`}
              loading
            />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          header={
            <TopBar
              rightSlot={
                <TransactionDropdown
                  transactions={addStatusToTransactions(
                    data.confirmedTransactions,
                    'confirmed'
                  )}
                />
              }
            />
          }
          bodyCentered
          body={
            <WidgetStatus
              emoji="⏳"
              title="Almost there!"
              description={
                <>
                  We just need to perform a final security verification.
                  <br /> This can take a few moments.
                </>
              }
            />
          }
          footer={
            <Button
              as="a"
              href={links.support.PAYMENT_CONFIRMATION}
              target="_blank"
              mt="16"
              size="large"
              variant="secondary"
              rightIcon={<Icon component={<BookOpenIcon />} />}
            >
              Learn more
            </Button>
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
};

export default KYTVerification;
